var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.password.length)?_c('div',[_vm._v(" Password strength: "),_c('span',{style:({color: _vm.strengths[_vm.score].color}),attrs:{"id":"password-strength"}},[_vm._v(" "+_vm._s(_vm.strengths[_vm.score].label)+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }